/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    // {
    //     id   : 'sellers',
    //     title: 'Sellers',
    //     type : 'basic',
    //     icon : 'mat_outline:business',
    //     link : '/sellers'
    // },
];
export const compactNavigation: FuseNavigationItem[] = [
//    {
//         id   : 'sellers',
//         title: 'Sellers',
//         type : 'basic',
//         icon : 'mat_outline:business',
//         link : '/sellers'
//     },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    // {
    //     id   : 'sellers',
    //     title: 'Sellers',
    //     type : 'basic',
    //     icon : 'mat_outline:business',
    //     link : '/sellers'
    // },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    // {
    //     id   : 'sellers',
    //     title: 'Sellers',
    //     type : 'basic',
    //     icon : 'mat_outline:business',
    //     link : '/sellers'
    // },
];
